//component
import ModalMaster from "@/components/Modal/ModalMaster.vue";
//store
import ModalStore from '@/store/ModalStore';
//modal controller
import { ModalController } from '@/components/Modal/ModalController.js';
import { AlertModalController } from '@/components/Modal/Generic/AlertModal/AlertModalController';
import { ConfirmModalController } from '@/components/Modal/Generic/ConfirmModal/ConfirmModalController';
import { LoadingModalController } from '@/components/Modal/Generic/LoadingModal/LoadingModalController';
import { TracesModalController } from '@/module/Register/modal/tracesModal/TracesModalController';
import { BadgesModalController } from '@/module/Register/modal/badgesModal/BadgesModalController';
import { LoadingDeliveryModalController } from '@/module/ShoppingCart/modal/LoadingDeliveryModal/LoadingDeliveryModalController';
import { ConfirmRedeemModalController } from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModalController';
import { SerialModalController } from '@/module/Detail/modal/SerialModal/SerialModalController';
import { DrawDeliveryModalController } from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModalController';
import { ShippingAddressModalController } from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModalController';
import { AddAddressModalController } from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModalController';
import { EditAddressModalController } from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModalController';
import { ListAddressModalController } from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModalController';
import { AddTaxAddressModalController } from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModalController';
import { EditTaxAddressModalController } from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModalController';
import { ListTaxAddressModalController } from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModalController';
import { OtpModalController } from '@/components/Modal/Otp/OtpModalController';
import { ConfirmCouponModalController } from '@/module/Coupon/modal/ConfirmCouponModal/ConfirmCouponModalController';
import { ConditionCouponModalController } from '@/module/Coupon/modal/ConditionCouponModal/ConditionCouponModalController'
import { UpsaleModalController } from '@/module/ShoppingCart/modal/UpsaleModal/UpsaleModalController';
import { ConfirmTwoButtonModalController } from '@/module/ShoppingCart/modal/ConfirmTwoButtonModal/ConfirmTwoButtonModalController'
import { ConfirmGuestLoginModalController } from '@/module/Login/modal/ConfirmGuestLoginModal/ConfirmGuestLoginModalController';
import { ConfirmResetPasswordModalController } from '@/module/ResetPassword/modal/ConfirmResetPasswordModal/ConfirmResetPasswordModalController';
import { SuccessModalController } from '@/components/Modal/Generic/SuccessModal/SuccessModalController';
import { OrderDetailModalController } from '@/module/MyOrder/modal/OrderDetailModal/OrderDetailModalController';
import { FreeGiftModalController } from "@/module/MyOrder/modal/FreeGiftModal/FreeGiftModalController";
import { ConfirmRedeemRewardModalController } from '@/module/Reward/Detail/modal/ConfirmRedeemReward/ConfirmRedeemRewardModalController';
import { ConfirmUseRewardModalController } from '@/module/Reward/Detail/modal/ConfirmUseReward/ConfirmUseRewardModalController';
import { ErrorModalController } from '@/components/Modal/Generic/ErrorModal/ErrorModalController';
import { StoreDetailModalController } from '@/module/Store/modal/StoreDetailModal/StoreDetailModalController';
import { NotificationModalController } from "@/components/Modal/Notification/NotificationModalController";
import { QRPaymentModalController } from '@/module/ShoppingCart/modal/QRPaymentModal/QRPaymentModalController'
import { ConfirmRedeemSubscriptionModalController } from '@/module/Reward/Detail/modal/ConfirmRedeemSubscription/ConfirmRedeemSubscriptionModalController';
import { PdpaModalController } from "@/components/Modal/Authen/PdpaModal/PdpaModalController";

export default {
    provide: {
        ModalStore: ModalStore,
    },
    components: {
        ModalMaster,
    },
    data: function () {
        return {
            modalController: null,
        };
    },
    created: function () {
        this.initModal();
        this.connectModal();
        ModalStore.methods.setModalController(this.modalController);
    },
    methods: {
        initModal: function () {
            this.modalController = new ModalController();
            //Generic
            this.modalController.setAlertModal(new AlertModalController());
            this.modalController.setConfirmModal(new ConfirmModalController());
            this.modalController.setLoadingModal(new LoadingModalController());
            this.modalController.setLoadingDeliveryModal(new LoadingDeliveryModalController());
            this.modalController.setSuccessModal(new SuccessModalController());
            this.modalController.setErrorModal(new ErrorModalController());
            //traces and badges
            this.modalController.setTracesModal(new TracesModalController());
            this.modalController.setBadgesModal(new BadgesModalController());
            //Redeem
            this.modalController.setConfirmRedeemModal(new ConfirmRedeemModalController());
            this.modalController.setSerialModal(new SerialModalController());
            this.modalController.setDrawDeliveryModal(new DrawDeliveryModalController());
            this.modalController.setShippingAddressModal(new ShippingAddressModalController());
            this.modalController.setConfirmRedeemRewardModal(new ConfirmRedeemRewardModalController());
            this.modalController.setConfirmUseRewardModal(new ConfirmUseRewardModalController());
            this.modalController.setConfirmRedeemSubscriptionModal(new ConfirmRedeemSubscriptionModalController());
            //Address
            this.modalController.setAddAddressModal(new AddAddressModalController());
            this.modalController.setEditAddressModal(new EditAddressModalController());
            this.modalController.setListAddressModal(new ListAddressModalController());
            //Tax
            this.modalController.setAddTaxAddressModal(new AddTaxAddressModalController());
            this.modalController.setEditTaxAddressModal(new EditTaxAddressModalController());
            this.modalController.setListTaxAddressModal(new ListTaxAddressModalController());
            //OTP
            this.modalController.setOtpModal(new OtpModalController());
            //coupon
            this.modalController.setConfirmCouponModal(new ConfirmCouponModalController());
            this.modalController.setConditionCouponModal(new ConditionCouponModalController())
            //shopping cart
            this.modalController.setUpsaleModal(new UpsaleModalController());
            this.modalController.setConfirmTwoButtonModal(new ConfirmTwoButtonModalController());
            //Login
            this.modalController.setConfirmGuestLoginModal(new ConfirmGuestLoginModalController());
            this.modalController.setConfirmResetPasswordModal(new ConfirmResetPasswordModalController());
            //Myorder
            this.modalController.setMyorderModal(new OrderDetailModalController());
            this.modalController.setFreeGiftModal(new FreeGiftModalController());
            //Store
            this.modalController.setStoreDetailModal(new StoreDetailModalController());
            // custom
            this.modalController.setNotificationModal(new NotificationModalController());
            //payment
            this.modalController.setQRPaymentModal(new QRPaymentModalController());
            //Pdpa
            this.modalController.setPdpaModal(new PdpaModalController());
            
        },
        connectModal: function () {
            //addAddressModal
            this.modalController.addAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.addAddressModal.setLoadingModal(this.modalController.loadingModal);
            //editAddressModal
            this.modalController.editAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.editAddressModal.setLoadingModal(this.modalController.loadingModal);
            //listAddressModal
            this.modalController.listAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.listAddressModal.setConfirmModal(this.modalController.confirmModal);
            this.modalController.listAddressModal.setLoadingModal(this.modalController.loadingModal);
            this.modalController.listAddressModal.setAddAddressModal(this.modalController.addAddressModal);
            this.modalController.listAddressModal.setEditAddressModal(this.modalController.editAddressModal);
            //addTaxAddressModal
            this.modalController.addTaxAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.addTaxAddressModal.setLoadingModal(this.modalController.loadingModal);
            //editTaxAddressModal
            this.modalController.editTaxAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.editTaxAddressModal.setLoadingModal(this.modalController.loadingModal);
            //listTaxAddressModal
            this.modalController.listTaxAddressModal.setAlertModal(this.modalController.alertModal);
            this.modalController.listTaxAddressModal.setConfirmModal(this.modalController.confirmModal);
            this.modalController.listTaxAddressModal.setLoadingModal(this.modalController.loadingModal);
            this.modalController.listTaxAddressModal.setAddAddressModal(this.modalController.addTaxAddressModal);
            this.modalController.listTaxAddressModal.setEditAddressModal(this.modalController.editTaxAddressModal);
        },
    }
}
